import ActionButton from "./ActionButton";
import * as styleSheet from "../styles";
import { Box } from "@enaep-ng/benchmark";
import { ActionButtonRowProps } from "../types";

export default function ActionButtonRow({
  actionContainerStyle,
  ...props
}: ActionButtonRowProps) {
  return (
    <Box style={actionContainerStyle} sx={styleSheet.actionContainer}>
      <Box sx={{ display: "flex" }}>
        {props.actions.map(function (action, index) {
          const act = {
            ...action,
            elemKey: index,
          };
          return (
            <Box sx={{ flex: "1 0" }} key={`column-${index}`}>
              <ActionButton {...act} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
